import styled, { css } from 'styled-components';

import Divider from '@Components/atoms/Divider';
import Headline from '@Components/atoms/Headline';
import Row from '@Components/atoms/Row';
import Text from '@Components/atoms/Text';

export const StyledHeadline = styled(Headline)`
  margin-bottom: ${(props) => props.theme.space.xs_4};
`;

export const PositionHeaderText = styled(Text)`
  padding-left: ${(props) => props.theme.space.xs_4};
  min-width: 2rem;
  font-size: 10px; //todo: theme
`;

export const WpmHeaderText = styled(Text)`
  font-size: 10px; //todo: theme
  padding-right: ${(props) => props.theme.space.small_8};
`;

const iconWrapper = (offset: string) => css`
  display: flex;
  justify-content: right;
  min-width: 2rem;
  // due to the small svg padding, the icon does not look aligned with the text, even though it is, so we need to adjust the spacing a bit
  padding-right: calc(${(props) => props.theme.space.small_8} - ${offset});
`;

export const ScoreIconWrapper = styled.div`
  ${iconWrapper('1px')}
`;

export const CreatedAtIconWrapper = styled.div`
  ${iconWrapper('2px')}
`;

export const PercentageIconWrapper = styled.div`
  ${iconWrapper('2px')}
`;

export const TestsTakenIconWrapper = styled.div`
  ${iconWrapper('4px')}
`;

export const EmptyRow = styled(Row)`
  min-height: ${(props) => props.theme.space.xl_64};

  border-top: 1px solid ${(props) => props.theme.palette.divider.default};
  padding-top: ${(props) => props.theme.space.large_32};
  transition: border ${(props) => props.theme.transition.theme};
`;

export const StyledDivider = styled(Divider)`
  margin-bottom: 0;
`;
